<template>
    <div style="text-align: center;color:#FFFFFF;">
        <a href="/"><img src="../../assets/images/logo.png" alt=""/></a>
        <h1>Page not Found :(</h1>
    </div>
</template>
<script>

    export default {
        name: "PasswordResetSuccess",
        data() {
            return {
            };
        },
    };
</script>
<style scoped>
</style>
